import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from '../../models/confirmar-respuesta.model';

@Component({
	selector: 'app-modal-confirmar-respuesta',
	templateUrl: './modal-confirmar-respuesta.component.html',
	styleUrls: ['./modal-confirmar-respuesta.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalConfirmarRespuestaComponent implements OnInit {

	@Input()
	confirmarRespuesta: ConfirmarRespuestaModel;
	tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta;
	constructor(public activeModal: NgbActiveModal) {
	}

	ngOnInit() {
		switch (this.confirmarRespuesta.type) {
			case ConfirmarRespuestaType.Atencion:
				this.confirmarRespuesta.imagen = '/assets/images/atencion-modal.png';
				break;
		}
	}

	confirm(): void {
		this.activeModal.close();
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}
}
